export enum CloverPointConnectionType {
  WIFI = "wifi",
  ETHERNET = "ethernet",
  PHONE = "cellular",
}